//created by arindyproject
import { Component, Vue, Prop } from 'vue-facing-decorator';

@Component({
    name: 'comp-yt-comp',
})
export default class YTComp extends Vue{
    @Prop() url!: any;

    // Mengambil ID video dari URL YouTube
    get videoUrl() {
        if (this.url) {
            try {
                const urlParams = new URLSearchParams(new URL(this.url).search);
                const videoId = urlParams.get('v');
                if (videoId) {
                    //console.log(videoId)
                    return `https://www.youtube.com/embed/${videoId}`;
                }
            } catch (error) {
                console.error('Invalid YouTube URL:', error);
            }
        }
        return '';
    }
}
        